/**
 * Sidebar Icon
 *
 */

import type { SVGProps } from 'react'

export default function naming(props: SVGProps<SVGSVGElement> = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25 17.25C6.90685 17.25 8.25 15.9069 8.25 14.25C8.25 12.5931 6.90685 11.25 5.25 11.25C3.59315 11.25 2.25 12.5931 2.25 14.25C2.25 15.9069 3.59315 17.25 5.25 17.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 23.25C0.75 22.0565 1.22411 20.9119 2.06802 20.068C2.91193 19.2241 4.05653 18.75 5.25 18.75C6.44347 18.75 7.58807 19.2241 8.43198 20.068C9.27589 20.9119 9.75 22.0565 9.75 23.25H0.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.349 12.75C21.5784 13.1485 21.7132 13.5945 21.7428 14.0534C21.7724 14.5123 21.6961 14.9719 21.5199 15.3966C21.3436 15.8213 21.072 16.1999 20.7262 16.5029C20.3803 16.806 19.9694 17.0255 19.5252 17.1445C19.081 17.2635 18.6154 17.2788 18.1644 17.1891C17.7133 17.0995 17.2889 16.9074 16.924 16.6277C16.559 16.3479 16.2632 15.988 16.0595 15.5757C15.8558 15.1634 15.7495 14.7099 15.749 14.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 23.25C14.25 22.0565 14.7241 20.9119 15.568 20.068C16.4119 19.2241 17.5565 18.75 18.75 18.75C19.9435 18.75 21.0881 19.2241 21.932 20.068C22.7759 20.9119 23.25 22.0565 23.25 23.25H14.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 9.75H12V14.25L16.5 9.75H22.5V0.75H6.75V9.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5959 3L19.4999 5.25L17.5959 7.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.654 3L9.75 5.25L11.654 7.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3L14.25 7.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
